/** Connexion */
export default {
  label: {
    code: 'Connexion par SMS',
    pswd: 'Connexion par mot de passe'
  },
  phone: 'Numéro de téléphone',
  password: 'Mot de passe de connexion',
  code: 'Vérification {type}',
  sms: 'SMS',
  img: 'Image',
  getCode: 'Envoyer',
  login: 'Connexion',
  // Sélection du commerçant
  choose: 'Sélectionner un commerçant',
  // Conseils
  agree: 'Les numéros de téléphone non enregistrés seront automatiquement enregistrés. La case à cocher signifie accord et acceptation',
  agreement: '《Accord utilisateur de la plateforme commerçante》',
  second: 's',
  // Connexion WeChat
  wx: 'Connexion WeChat',
  // Plateforme de gestion d'activités
  activity_platform: {
    title: "Plateforme de gestion d'activités",
    subtitle: 'Du simple au complexe, des variations et paramètres infinis pour répondre à vos besoins en activités',
    features: [
      'Publication de grandes activités à travers plusieurs tours et groupes de catégories',
      'Augmentation de la visibilité de vos activités via les classements de popularité',
      'Réalisation de promotions multiformes via le chargement de publicités',
      'Sélection précise des meilleurs participants via une évaluation multidimensionnelle',
      "Présentation de scènes colorées via le téléchargement d'images et de vidéos"
    ]
  },
  // Évaluation et promotion
  evaluation: {
    title: 'Évaluation et promotion',
    subtitle: 'Évaluation multidimensionnelle pour la sélection la plus équitable et formelle',
    features: [
      "Création de schémas d'évaluation multidimensionnels pour différents groupes, sélection composite",
      'Choix entre évaluation et jugement',
      'Plusieurs juges évaluent et notent simultanément pour une autorité équitable',
      "Opération en un clic pour le filtrage des participants, la promotion et l'élimination",
      'Création de certificats et de classements pour les participants exceptionnels'
    ]
  },
  // Moments merveilleux
  moments: {
    title: 'Moments merveilleux',
    subtitle: 'Enregistrement de moments précieux dans les activités via des images et des vidéos',
    features: [
      "Téléchargement d'images ou de vidéos, publication sur mobile comme souvenirs de moments merveilleux",
      "Gestion efficace via des tags et des catégories d'images et de vidéos",
      "Téléchargement d'images et de vidéos pour les utilisateurs pour conserver définitivement les moments forts"
    ]
  },
  // Classements de popularité
  popularity: {
    title: 'Classements de popularité',
    subtitle: 'Reflet parfait de la popularité des activités via les listes de classement',
    features: [
      "Classements des likes, un vote par personne montre la haute popularité de l'activité",
      'Classements des cadeaux, contribuez au soutien des participants populaires',
      'Classements multi-étapes montrant différentes popularités à différentes étapes',
      'Classements par groupes montrant les participants populaires dans différents groupes'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/fr/login.js